import React from 'react';

// Internal imports (components, hooks, utils)
import { LinkButton } from 'src/app/components/lib/button/link-button';
import { DropdownMultiple } from 'src/app/components/lib/dropdown';
import { useGetMarketingTagsQuery } from 'src/app/queries/marketing/marketing-tags/get-marketing-tags';

import type { DropdownMenuOption } from 'src/app/components/lib/dropdown';

// Types
type MarketingTagsDropdownProps = {
  automationId?: string;
  disabled?: boolean;
  label?: string;
  labelPlacement?: 'start' | 'top';
  onChange: (ids: number[]) => void;
  placeholder?: string;
  refreshButtonAutomationId?: string;
  required?: boolean;
  searchAutomationId?: string;
  selectAllButtonAutomationId?: string;
  selectNoneButtonAutomationId?: string;
  value: number[];
};

export function MarketingTagsDropdown(props: MarketingTagsDropdownProps) {
  const {
    automationId,
    disabled,
    placeholder,
    label,
    labelPlacement,
    refreshButtonAutomationId,
    required,
    searchAutomationId,
    selectAllButtonAutomationId,
    selectNoneButtonAutomationId,
    value,
    onChange,
  } = props;

  // Query hooks
  const { data: marketingTags = [], refetch } = useGetMarketingTagsQuery();

  const options = marketingTags.map(({ MarketingTagId, TagName }) => ({
    id: String(MarketingTagId),
    label: TagName,
  }));

  const parsedValue = value.map((id) => ({ id: String(id), label: '' }));

  // Event handlers
  function handleChange(payload: DropdownMenuOption[]) {
    const parsedPayload = payload.map(({ id }) => parseInt(String(id), 10));
    onChange(parsedPayload);
  }

  const handleRefresh = () => {
    void refetch();
  };

  return (
    <DropdownMultiple
      automationId={automationId}
      disabled={disabled}
      footerContent={<LinkButton automationId={refreshButtonAutomationId} label='Refresh' onClick={handleRefresh} />}
      helpText={placeholder}
      label={label}
      labelPlacement={labelPlacement}
      options={options}
      required={required}
      searchAutomationId={searchAutomationId}
      selectAllButtonAutomationId={selectAllButtonAutomationId}
      selectNoneButtonAutomationId={selectNoneButtonAutomationId}
      setValue={handleChange}
      value={parsedValue}
    />
  );
}
